import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["_id", "name", "description", "image", "gatsbyImage", "imageAltText", "available"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React, { useContext, useState } from 'react';
import { getContainerClassName } from './ItemContainer.utils';
import { MenuContext, VariantContext, FoodMenuCartContext } from '../../../../FoodMenu.context';
import MenuUtil from '../../../../utils/menu';
import { itemVariantComponentMap, itemModalVariantComponentMap } from '../index';
import '../Item.css';
var defaultProps = {
  displayImages: true
};
export function ItemContainer(_ref) {
  var itemId = _ref.itemId,
    displayImages = _ref.displayImages;
  var _useContext = useContext(VariantContext),
    itemDisplay = _useContext.itemDisplay,
    itemCartModal = _useContext.itemCartModal;
  var _useContext2 = useContext(MenuContext),
    items = _useContext2.items,
    modifierSets = _useContext2.modifierSets,
    modifiers = _useContext2.modifiers;
  var cart = useContext(FoodMenuCartContext);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modalOpen = _useState2[0],
    setModalOpen = _useState2[1];
  function handleClose() {
    setModalOpen(false);
  }
  function handleOpen() {
    setModalOpen(true);
  }
  function onItemCartModalClick(e, available) {
    var targetClassName = e.target.className;
    // this will enable icons inside the cart container to be clickable and not display the cart modal
    if (targetClassName.includes('icon') && !targetClassName.includes('cart')) {
      e.preventDefault();
      return;
    }
    if (available) {
      handleOpen();
    }
  }
  var ItemComponent = itemVariantComponentMap[itemDisplay];
  var ModalComponent = itemModalVariantComponentMap[itemCartModal];
  var item = MenuUtil.getItemById(items, itemId);
  var _id = item._id,
    name = item.name,
    description = item.description,
    image = item.image,
    gatsbyImage = item.gatsbyImage,
    imageAltText = item.imageAltText,
    _item$available = item.available,
    available = _item$available === void 0 ? true : _item$available,
    restItem = _objectWithoutProperties(item, _excluded);
  var itemModifierSetIds = item.modifierSets;
  var itemModifierSets = MenuUtil.getItemModifierSets(itemModifierSetIds, modifierSets);
  var images = gatsbyImage || image ? [gatsbyImage || image] : [];
  var variations = MenuUtil.getMenuItemVariations(item);
  if (!cart) {
    return /*#__PURE__*/React.createElement(ItemComponent, _extends({
      className: getContainerClassName(item),
      isSingleVariation: MenuUtil.menuItemHasOneVariation(item),
      id: _id,
      name: name,
      description: description,
      image: image,
      imageAltText: imageAltText,
      gatsbyImage: gatsbyImage,
      variations: variations,
      displayImages: displayImages
    }, restItem));
  }
  var addItem = cart.addItem,
    cartLoading = cart.loading;
  return /*#__PURE__*/React.createElement(ModalComponent, {
    trigger: /*#__PURE__*/React.createElement(ItemComponent, _extends({
      className: getContainerClassName(item, available ? ['clickable'] : []),
      onClick: function onClick(e) {
        onItemCartModalClick(e, available);
      },
      isSingleVariation: MenuUtil.menuItemHasOneVariation(item),
      id: _id,
      name: name,
      description: description,
      image: image,
      gatsbyImage: gatsbyImage,
      variations: variations,
      displayImages: displayImages
    }, restItem)),
    open: modalOpen,
    onClose: handleClose,
    item: _objectSpread(_objectSpread({}, item), {}, {
      variations: variations
    }),
    modifiers: modifiers,
    modifierLists: itemModifierSets,
    onAddItem: addItem,
    disabled: cartLoading,
    images: images
    /* CatalogItemCartModal props */,
    modifierSets: itemModifierSets,
    variations: variations,
    cart: cart
  });
}
ItemContainer.defaultProps = defaultProps;
export default ItemContainer;